import styled from 'styled-components';

export const PostHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  padding-left: 15px;
  padding-right: 15px;
  width: calc(100%);
  top: 8px;
  z-index: 2;
`;

export const ImageNumber = styled.div`
  background-color: rgba(105, 105, 105, 0.16);
  align-items: center;
  font-size: 12px;
  border-radius: 12px;
  justify-content: center;
  padding-left: 6px;
  padding-right: 6px;
  display: flex;
  height: 21px;
  z-index: 2;
  color: rgba(255, 255, 255, 0.7);
`;

export const TopIconWrapper = styled.div`
  right: 8px;
  top: 8px;
  cursor: pointer;
`;

export const TriangleWrapper = styled.div`
  z-index: 10;
  margin-top: -35px;
  margin-bottom: -1px;
  align-self: center;
  display: flex;
`;
